exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".rcocxKjYngacjzrfuQENM ._2z4EjXHPmVOh2gqxYeDUt2{position:absolute;top:0}.rcocxKjYngacjzrfuQENM ._3h4ULv4_5r7O2sB470coSC ._1M8Xu1Q5N8tK9JgR_hYtgg{position:absolute}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "rcocxKjYngacjzrfuQENM",
	"glyph-margin": "_2z4EjXHPmVOh2gqxYeDUt2",
	"margin-view-overlays": "_3h4ULv4_5r7O2sB470coSC",
	"cgmr": "_1M8Xu1Q5N8tK9JgR_hYtgg"
};